import { createAction } from '@reduxjs/toolkit';
import { serviceConstants, utilConstants } from '../constants';


export const setLoader = createAction(
    utilConstants.SET_LOADER,
    (payload) => ({ payload })
  );